/**
 * Registry de dashboards por vertical.
 *
 * La vertical la resuelve el BACKEND (routes/auth.get_me → `user.dashboard_vertical`,
 * fuente ÚNICA core/inventory_resolver.resolve_company_vertical). El front YA NO la
 * calcula: aquí solo se LEE. Antes vivía `getVerticalKey(licenseType, businessType)`
 * (rota: ignoraba `industry` → todo caía a real_estate salvo car_dealer, y las keys
 * education/health/generic eran inalcanzables).
 *
 * Expone:
 *  - `verticalFromUser(user)` → key de dashboard (real_estate | developments |
 *    automotive | education | generic). Default SEGURO = 'generic' (nunca cae a
 *    inmobiliaria por error si el backend viejo aún no manda la key).
 *  - `VERTICAL_BADGE_LABEL` → etiqueta en español para el badge del header.
 *  - `VendorDashboard` para el rol `vendor` (vista personal cross-vertical).
 */
import VendorDashboard from './VendorDashboard';

// Keys de dashboard válidas (espejo de las dashboard keys de core/inventory_resolver).
const DASHBOARD_KEYS = ['real_estate', 'developments', 'automotive', 'education', 'generic'];

// Etiqueta en español del badge por vertical. Mapa FIJO y versionado (nada de pintar
// el string crudo con .replace()).
export const VERTICAL_BADGE_LABEL = {
  real_estate: 'Inmobiliaria',
  developments: 'Desarrollos',
  automotive: 'Automotriz',
  education: 'Educación',
  generic: 'General',
};

/**
 * Lee la vertical de dashboard que el backend resolvió y expuso en /auth/me.
 * Default SEGURO 'generic' si el backend (viejo) aún no la manda o trae una key
 * desconocida — nunca cae a inmobiliaria por error.
 */
export function verticalFromUser(user) {
  const v = String(user?.dashboard_vertical || '').toLowerCase();
  return DASHBOARD_KEYS.includes(v) ? v : 'generic';
}

export { VendorDashboard };
